import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';

const Store = () => {
  return (
    <Layout
      headerMenu={false}
      onBack
      bottomMenu
    >
      <AppShell variant='full' padded={false}>
        <iframe
          className='embed-page'
          title='Tienda Luz Savinon'
          src='https://www.tiendaluzsavinon.com'
        />
      </AppShell>
    </Layout>
  );
};

export default Store;
